import EventEmitter from "events";
import mapValues from "lodash/mapValues";

const emitter = new EventEmitter();
const CHANGE = "change";

const RECENT_ORDER_THRESHOLD_MS = 3 * 7 * 24 * 60 * 60 * 1000;
const INTERVAL = process.env.NODE_ENV === "production" ? 10000 : 5000;

const state = {
  loading: false,
  error: undefined,
  data: undefined,
  orderIndex: 0,
  visible: false
};

const emitChangeDevelopment = actionName => {
  console.groupCollapsed("State Change Triggered", actionName);
  console.log(new Error().stack);
  console.groupEnd();

  setTimeout(() => {
    console.group("State Change Executed", actionName);
    console.log("State", state);
    emitter.emit(CHANGE);
    console.groupEnd();
  }, 0);
};

const emitChangeProduction = actionName => {
  setTimeout(() => {
    emitter.emit(CHANGE);
  }, 0);
};

const emitChange =
  process.env.NODE_ENV === "production"
    ? emitChangeProduction
    : emitChangeDevelopment;

const hookActions = actions =>
  mapValues(actions, (action, name) => (...args) => {
    action(...args);
    emitChange(name);
  });

const store = {
  subsribe(callback) {
    emitter.addListener(CHANGE, callback);
  },

  unsubsribe(callback) {
    emitter.removeListener(CHANGE, callback);
  },

  selectors: {
    getInterval() {
      return INTERVAL;
    },

    getVisibilityInterval() {
      return INTERVAL / 2;
    },

    isLoading() {
      return state.loading;
    },

    hasError() {
      return !!state.error;
    },

    getError() {
      return state.error;
    },

    hasData() {
      return state.data && state.data.length > 0;
    },

    getData() {
      return state.data;
    },

    getCurrentOrder() {
      return state.data && state.data[state.orderIndex];
    },

    isCurrentOrderRecent() {
      return (
        state.data &&
        state.data[state.orderIndex] &&
        Date.now() - new Date(state.data[state.orderIndex].when).getTime() <
          RECENT_ORDER_THRESHOLD_MS
      );
    },

    isWidgetVisible() {
      return state.visible;
    },

    shouldAnimateCheckmark() {
      return !state.visible;
    }
  },

  actions: hookActions({
    updateOrders(loading, error, data) {
      state.loading = loading;
      state.error = error;
      state.data = data;
    },

    transitionToNextOrder() {
      if (state.data && state.data.length) {
        state.orderIndex = (state.orderIndex + 1) % state.data.length;
      }
    },

    toggleWidgetVisibility() {
      state.visible = !state.visible;
    }
  })
};

export default store;
